import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function OpeningHook() {
  return <section className="py-24 px-6 bg-dark/50 relative border-y border-white/5" data-id="element-133">
      <div className="max-w-3xl mx-auto relative" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="relative" data-id="element-135">
          <QuoteIcon className="absolute -top-10 -left-8 w-16 h-16 text-gold-500/10 rotate-180" data-id="element-136" />

          <div className="space-y-8 text-xl md:text-2xl font-display italic leading-relaxed text-gray-300" data-id="element-137">
            <p data-id="element-138">
              Recibes tu primer cheque y la tentación es inmediata: ropa nueva,
              ese auto que "te mereces", o simplemente gastar porque finalmente
              tienes el control.{' '}
              <span className="text-white font-bold" data-id="element-139">
                Pero en Estados Unidos, si no tienes un plan para tu dinero
                antes de que llegue a tu cuenta, el sistema ya tiene un plan
                para quitártelo.
              </span>
            </p>
            <p data-id="element-140">
              No es tu culpa no saber cómo manejarlo. Venimos de familias donde
              el dinero era un tema tabú o una fuente de estrés, y donde los
              consejos de "ahorra en el colchón" simplemente no funcionan en el
              sistema americano actual.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}